module.exports = __webpack_public_path__ + "img/Nissan.e197728b.jpg";